<template>
  <div class="order-line" @click="vGoToOrderDetail">
    <div class="order-line-cell">
      <span>{{$dateformat(lineData.tdate_cde)}}</span>
    </div>
    <div class="order-line-cell">
      <span>{{lineData.tncde}}</span>
    </div>
    <div class="order-line-cell">
      <span>{{lineData.tfref}}</span>
    </div>
    <div class="order-line-cell">
      <span>{{lineData.tmont}} {{lineData.tcdev}}</span>
    </div>
    <div class="order-line-cell">
      <span>{{oMappingStatus[lineData.tstatut]}}</span>
    </div>
    <div class="order-line-cell">
      <span>{{lineData.tp_liv}} %</span>
    </div>
    <div class="order-line-cell">
      <span>{{lineData.tp_ral}} %</span>
    </div>
    <div class="order-line-cell">
      <span>{{this.$dateformat(lineData.tdelai)}}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: ["dataline"],
  data() {
    return {
      oMappingStatus: {
        "@": this.$_('in_progress'),
        "S": this.$_('sale'),
        "*": this.$_('deleted')
      },
      lineData: {
        tdate_cde: this.$props.dataline.TDATE_CDE,
        tncde: this.$props.dataline.TNCDE,
        tfref: this.$props.dataline.TREF,
        tmont: this.$props.dataline.TMONT,
        tstatut: this.$props.dataline.TSTATUT,
        tp_liv: this.$props.dataline.TP_LIV,
        tp_ral: this.$props.dataline.TP_RAL,
        tdelai: this.$props.dataline.TDELAI,
        tcdev: this.$store.getters['application/get_application_customer'].TCDEV
      }
    };
  },
  methods: {
    vGoToOrderDetail() {
      this.$store.dispatch("commande/SELECT", {
        key: "pnocde",
        value: this.$props.dataline.TNCDE
      });
      this.$router.push({
        name: "detailorder",
        params: { order_id: this.$props.dataline.TNCDE }
      });
    }
  }
};
</script>

<style scoped>
.order-line {
  display: flex;
  border: solid 1px #e9e9e9;
  margin-top: 10px;
  transition: all 0.3s;
  align-items: center;
}
.order-line-cell {
  display: flex;
  width: calc(100% / 8);
  justify-content: center;
  padding: 25px 0px;
}
.order-line-cell span {
  color: #585858;
  font-size: var(--fz-md);
  transition: all 0.3s;
}
.order-line:hover {
  background-color: #f5f5f5;
  cursor: pointer;
}
.order-line:hover .order-line-cell span {
  color: #8b8b8b;
}
</style>